import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import {
  AVAILABILITY_FIND_ALL,
  AVAILABILITY_FIND_ALL_SUCCESS,
  AVAILABILITY_FAILED,
  AVAILABILITY_UPDATE_LOADING,
 } from '../actions'
import { AvailabilityService } from '@core/services';
import { Store } from '@ngrx/store';
import { selectLocalChannelId } from '../selectors';
import { Availability } from '@core/models';

@Injectable()
export class AvailabilityEffects {

  constructor(
    private actions$: Actions,
    private availabilityService: AvailabilityService,
    private store: Store
  ) {}

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AVAILABILITY_FIND_ALL),
      withLatestFrom(this.store.select(selectLocalChannelId)),
      mergeMap(([,localChannelId]) => {
        this.store.dispatch(AVAILABILITY_UPDATE_LOADING({loading:true}))
        return this.availabilityService.getAvailability(localChannelId).pipe(
          mergeMap(({ data }) => {
            const availabilityList = data as Availability[]

            return [
              AVAILABILITY_FIND_ALL_SUCCESS({ availabilityList }),
              AVAILABILITY_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) =>
            of(
              AVAILABILITY_FAILED({
                error: error.error?.message || 'Error loading availability',
              })
            )
          )
        )
      }
      )
    )
  );
}
